(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5561],{

/***/ 20831:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/upcoming",
      function () {
        return __webpack_require__(54823);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 29894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ H1Smaller; },
/* harmony export */   "H1": function() { return /* binding */ H1; },
/* harmony export */   "H2": function() { return /* binding */ H2; },
/* harmony export */   "H3": function() { return /* binding */ H3; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68251);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73098);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        padding: 0 26px;\n        &:before {\n          width: 10px;\n          height: 41px;\n        }\n\n        ",
        " {\n          margin-left: -35px;\n          margin-bottom: 30px;\n        }\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n      padding-left: 30px;\n\n      ",
        " {\n        padding-left: 40px;\n      }\n\n      &::before {\n        content: '';\n        background-color: currentColor;\n        position: absolute;\n        top: -5px;\n        bottom: 0;\n        height: 70px;\n        left: 5px;\n        width: 17px;\n        clip-path: polygon(0 0, 40% 0, 100% 100%, 90% 100%);\n      }\n\n      ",
        " {\n        padding-left: 0;\n        padding-right: 30px;\n\n        ",
        " {\n          padding-left: 0;\n          padding-right: 40px;\n        }\n\n        &::before {\n          left: auto;\n          right: 5px;\n          clip-path: polygon(60% 0, 100% 0, 10% 100%, 0 100%);\n\n          ",
        " {\n            right: 0;\n          }\n        }\n      }\n\n      ",
        "\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  font-weight: 300;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n\n  font-size: 24px;\n  line-height: 120%;\n\n  color: ",
        ";\n  margin-bottom: 20px;\n\n  ",
        " {\n    font-size: 32px;\n    margin-bottom: 30px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      position: relative;\n      padding-left: 12px;\n\n      &::before {\n        content: '';\n        background-color: currentColor;\n        position: absolute;\n        clip-path: polygon(0 0, 40% 0, 100% 100%, 90% 100%);\n        top: -2px;\n        height: 21px;\n        left: 0;\n        width: 5px;\n      }\n\n      ",
        " {\n        padding-left: 0;\n        padding-right: 12px;\n\n        &::before {\n          left: auto;\n          right: 0;\n          clip-path: polygon(60% 0, 100% 0, 10% 100%, 0 100%);\n        }\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 120%;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n\n  color: ",
        ";\n  margin-bottom: 20px;\n\n  ",
        " {\n    font-size: 16px;\n    margin-bottom: 20px;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 14px;\n\n  font-weight: 400;\n  letter-spacing: 0.04em;\n  text-align: left;\n\n  display: flex;\n  align-items: center;\n  text-transform: uppercase;\n\n  color: ",
        ";\n  margin-bottom: ",
        "px;\n\n  ",
        " {\n    font-size: 16px;\n    text-align: center;\n    margin-bottom: ",
        "px;\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-style: normal;\n  font-weight: 300;\n  text-transform: uppercase;\n  font-size: 14px;\n  line-height: 130%;\n  text-align: center;\n  margin-left: -30px;\n  margin-bottom: 18px;\n  letter-spacing: 2rpx;\n\n  ",
        " {\n    text-align: left;\n    font-size: 16px;\n    letter-spacing: 0.64rpx;\n    margin-left: 0;\n  }\n  ",
        " {\n    margin-left: 0;\n    margin-right: -30px;\n    ",
        " {\n      text-align: right;\n      margin-right: 0;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var H1 = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h1.withConfig({
    displayName: "Header__H1",
    componentId: "sc-7f32335b-0"
})(_templateObject2(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.accent;
}), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, function(param) {
    var _$nail = param.$nail, $nail = _$nail === void 0 ? true : _$nail;
    return $nail && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject1(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .dirRTL */ .gX, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, $nail === "outside" && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject(), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop));
});
var H1Smaller = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h1.withConfig({
    displayName: "Header__H1Smaller",
    componentId: "sc-7f32335b-1"
})(_templateObject4(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.accent;
}), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, function(param) {
    var _$nail = param.$nail, $nail = _$nail === void 0 ? true : _$nail;
    return $nail && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__.css)(_templateObject3(), src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .dirRTL */ .gX);
});
var H2 = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h2.withConfig({
    displayName: "Header__H2",
    componentId: "sc-7f32335b-2"
})(_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.text.palette.accent;
}, function(param) {
    var theme = param.theme;
    return theme.spacing.gap * 0.5;
}, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.lessThan.desktop */ .BC.w.lessThan.desktop, function(param) {
    var theme = param.theme;
    return theme.spacing.gap * 0.75;
});
var H3 = styled_components__WEBPACK_IMPORTED_MODULE_3__["default"].h3.withConfig({
    displayName: "Header__H3",
    componentId: "sc-7f32335b-3"
})(_templateObject6(), (0,src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .fromTheme */ .HW)(function(theme) {
    return theme.text.palette.primary;
}), src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop, src_styles_theme__WEBPACK_IMPORTED_MODULE_1__/* .dirRTL */ .gX, src_styles_designs__WEBPACK_IMPORTED_MODULE_2__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);


/***/ }),

/***/ 51306:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ Paragraph; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87379);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 1.5;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Paragraph = styled_components__WEBPACK_IMPORTED_MODULE_1__["default"].p.withConfig({
    displayName: "Text__Paragraph",
    componentId: "sc-ee167d0d-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});


/***/ }),

/***/ 93928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ useUpcomingEventsListQuery; }
/* harmony export */ });
/* unused harmony export fetchUpcomingEventsList */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20414);
/* harmony import */ var src_models_query__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19162);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69119);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(78420);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(88767);
/* harmony import */ var src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53100);
/* harmony import */ var src_modules_events_hooks_useEventsListQuery__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56760);







var fetchUpcomingEventsList = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function(apis) {
        var events;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_5__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,src_modules_events_hooks_useEventsListQuery__WEBPACK_IMPORTED_MODULE_3__/* .fetchEventsList */ .l)(apis, {
                            filters: {
                                endDate: {
                                    _gte: (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new Date()).toISOString()
                                }
                            }
                        })
                    ];
                case 1:
                    events = _state.sent();
                    return [
                        2,
                        events.filter(function(event) {
                            return (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(event.endDate).getTime() > new Date().getTime();
                        }).sort(function(a, b) {
                            return (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(a.startDate).getTime() - (0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(b.startDate).getTime();
                        })
                    ];
            }
        });
    });
    return function fetchUpcomingEventsList(apis) {
        return _ref.apply(this, arguments);
    };
}();
var useUpcomingEventsListQuery = function() {
    var apis = (0,src_hooks_useAPIs__WEBPACK_IMPORTED_MODULE_2__/* .useAPIs */ .V)();
    return (0,react_query__WEBPACK_IMPORTED_MODULE_1__.useQuery)(src_models_query__WEBPACK_IMPORTED_MODULE_0__/* .QueryKey.UpcomingEventsList */ .S.UpcomingEventsList, function() {
        return fetchUpcomingEventsList(apis);
    });
};


/***/ }),

/***/ 51961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ EventsGalleryTemplate; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87379);
/* harmony import */ var src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71008);
/* harmony import */ var src_styles_theme__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(68251);
/* harmony import */ var src_styles_designs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(73098);
/* harmony import */ var src_components_common_typography_Text__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51306);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14332);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(17739);
/* harmony import */ var react_t7e__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(react_t7e__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12732);
/* harmony import */ var src_components_common_StickyMenu__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(25196);
/* harmony import */ var src_components_seo_MetaTitle__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71508);
/* harmony import */ var src_components_seo_MetaDescription__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(89080);
/* harmony import */ var src_services_route__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(38325);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  z-index: 50;\n  width: 100%;\n  pointer-events: none;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n        position: static;\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  &&& {\n    ",
        ";\n\n    pointer-events: all;\n    .sticky-menu__navbar {\n      background: transparent;\n    }\n    .sticky-menu__button {\n      justify-content: start;\n      ",
        " {\n        min-width: 220px;\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      padding-bottom: 30px;\n\n      ",
        " {\n        padding-bottom: 100px;\n      }\n    "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  text-align: center;\n  padding-top: 100px;\n\n  ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 16px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}














var StickyUIContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    displayName: "EventsGalleryTemplate__StickyUIContainer",
    componentId: "sc-34bdb64a-0"
})(_templateObject());
var StickyMenuContainer = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].div.withConfig({
    displayName: "EventsGalleryTemplate__StickyMenuContainer",
    componentId: "sc-34bdb64a-1"
})(_templateObject1());
var StyledStickyMenu = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__["default"])(src_components_common_StickyMenu__WEBPACK_IMPORTED_MODULE_8__/* .StickyMenu */ .a).withConfig({
    displayName: "EventsGalleryTemplate__StyledStickyMenu",
    componentId: "sc-34bdb64a-2"
})(_templateObject3(), (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_7__/* .casePathEmptyString */ .Q)("$static")((0,styled_components__WEBPACK_IMPORTED_MODULE_12__.css)(_templateObject2())), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop);
var NoResultsContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_12__["default"])(src_components_common_ConstraintContainer__WEBPACK_IMPORTED_MODULE_3__/* .ConstraintContainer */ .a).withConfig({
    displayName: "EventsGalleryTemplate__NoResultsContainer",
    componentId: "sc-34bdb64a-3"
})(_templateObject5(), (0,src_utils_casePathEmptyString__WEBPACK_IMPORTED_MODULE_7__/* .casePathEmptyString */ .Q)("$space")((0,styled_components__WEBPACK_IMPORTED_MODULE_12__.css)(_templateObject4(), src_styles_designs__WEBPACK_IMPORTED_MODULE_5__/* .media.w.greaterThanOrEqual.desktop */ .BC.w.greaterThanOrEqual.desktop)));
var NoResultsHeading = styled_components__WEBPACK_IMPORTED_MODULE_12__["default"].h3.withConfig({
    displayName: "EventsGalleryTemplate__NoResultsHeading",
    componentId: "sc-34bdb64a-4"
})(_templateObject6());
var stickyMenuSections = [
    {
        id: "upcoming",
        label: "upcoming events",
        link: src_services_route__WEBPACK_IMPORTED_MODULE_11__/* .route.events */ .BC.events().upcoming()
    },
    {
        id: "past-global",
        label: "past global events",
        link: src_services_route__WEBPACK_IMPORTED_MODULE_11__/* .route.events */ .BC.events().pastGlobal()
    },
    {
        id: "past-local",
        label: "past local events",
        link: src_services_route__WEBPACK_IMPORTED_MODULE_11__/* .route.events */ .BC.events().pastLocal()
    }, 
];
var EventsGalleryTemplate = function(param) {
    var type = param.type, children = param.children, hasResults = param.hasResults, _staticMenu = param.staticMenu, staticMenu = _staticMenu === void 0 ? false : _staticMenu;
    var _ = (0,react_t7e__WEBPACK_IMPORTED_MODULE_13__.useTranslate)()._;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_seo_MetaTitle__WEBPACK_IMPORTED_MODULE_9__/* .MetaTitle */ .p, {
                children: _("seo.events.title", "events.".concat(type))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_seo_MetaDescription__WEBPACK_IMPORTED_MODULE_10__/* .MetaDescription */ .l, {
                children: _("seo.events.description", "events.".concat(type))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StickyUIContainer, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StickyMenuContainer, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledStickyMenu, {
                            $static: staticMenu,
                            tabs: stickyMenuSections,
                            theme: hasResults && !staticMenu ? src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .redTheme */ .MN : src_styles_theme__WEBPACK_IMPORTED_MODULE_4__/* .defaultTheme */ .uH,
                            activeTab: type,
                            transparentOnTop: !staticMenu
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_14__/* .AnimatePresence */ .M, {
                        exitBeforeEnter: true,
                        initial: false,
                        children: children
                    })
                ]
            }),
            !hasResults && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(NoResultsContainer, {
                $space: type === "upcoming",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(NoResultsHeading, {
                        children: _("Currently, there are no events in this category")
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(src_components_common_typography_Text__WEBPACK_IMPORTED_MODULE_6__/* .Paragraph */ .n, {
                        children: _("Please use different one, or come back later!")
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 54823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ upcoming; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./src/styles/theme.ts + 3 modules
var theme = __webpack_require__(68251);
// EXTERNAL MODULE: ./src/components/common/ConstraintContainer.tsx
var ConstraintContainer = __webpack_require__(71008);
// EXTERNAL MODULE: ./src/components/common/typography/Header.tsx
var Header = __webpack_require__(29894);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./src/modules/events/assets/lol-event-section.jpg
/* harmony default export */ var lol_event_section = ({"src":"/_next/static/media/lol-event-section.a526b109.jpg","height":3700,"width":2500,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAIAAUDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAfEAACAgEEAwAAAAAAAAAAAAABAgADBAUGERQhMVH/xAAVAQEBAAAAAAAAAAAAAAAAAAAEBf/EABsRAAIBBQAAAAAAAAAAAAAAAAABAgQREnGx/9oADAMBAAIRAxEAPwC2lbh7Ft1WfVjq1KooFikEHzz7J+REQ+TLUqeF1pcP/9k=","blurWidth":5,"blurHeight":8});
// EXTERNAL MODULE: ./src/styles/designs.ts
var designs = __webpack_require__(73098);
// EXTERNAL MODULE: ./node_modules/react-t7e/lib/index.js
var lib = __webpack_require__(17739);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./src/models/query.ts
var query = __webpack_require__(19162);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/hooks/useAPIs.ts
var useAPIs = __webpack_require__(53100);
// EXTERNAL MODULE: ./src/utils/gql/query.ts
var gql_query = __webpack_require__(72493);
;// CONCATENATED MODULE: ./src/modules/events/graphql/events-page.query.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query EventsPageList {\n    eventsPage {\n      neauviaExpertsCertificationLink\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var eventsPageGqlQuery = (0,gql_query/* gql */.Ps)(_templateObject());

;// CONCATENATED MODULE: ./src/modules/events/hooks/useUpcomingEventsPageQuery.ts






var fetchUpcomingEventsPage = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(apis) {
        var directus;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apis.directus()
                    ];
                case 1:
                    directus = _state.sent();
                    return [
                        2,
                        directus.query(eventsPageGqlQuery).then(function(d) {
                            return d.eventsPage;
                        })
                    ];
            }
        });
    });
    return function fetchUpcomingEventsPage(apis) {
        return _ref.apply(this, arguments);
    };
}();
var useUpcomingEventsPageQuery = function() {
    var apis = (0,useAPIs/* useAPIs */.V)();
    return (0,es.useQuery)(query/* QueryKey.UpcomingEventsPage */.S.UpcomingEventsPage, function() {
        return fetchUpcomingEventsPage(apis);
    });
};

// EXTERNAL MODULE: ./src/components/TrackedLink.tsx
var TrackedLink = __webpack_require__(79017);
// EXTERNAL MODULE: ./src/components/common/Button/index.tsx + 8 modules
var Button = __webpack_require__(78296);
;// CONCATENATED MODULE: ./src/modules/events/components/EventsPresentationGallery/EventsPresentationStaticSection.tsx

function EventsPresentationStaticSection_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-template-areas: 'image subtitle' 'image title' 'image description' 'image cta' 'image .';\n  grid-template-columns: auto 1fr;\n  grid-template-rows: 3fr auto auto auto 2fr;\n  justify-content: center;\n  grid-row-gap: 15px;\n  grid-column-gap: 10px;\n\n  ",
        " {\n    margin-top: 40px;\n    padding-left: 0;\n    ",
        " {\n      padding-left: var(--constraint-container-left-inner-margin);\n      padding-right: 0;\n    }\n  }\n\n  ",
        " {\n    grid-row-gap: 30px;\n    grid-column-gap: 40px;\n    margin-top: -30px;\n    grid-template-columns: auto 440px;\n\n    &:last-of-type {\n      margin-bottom: calc(-1 * var(--footer-static-height) * 0.27);\n    }\n  }\n"
    ]);
    EventsPresentationStaticSection_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: image;\n  justify-self: center;\n  height: 340px;\n  width: 130px;\n  position: relative;\n\n  ",
        " {\n    width: 386px;\n    height: 578px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: cover;\n  object-position: center center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: subtitle;\n  padding-left: 30px;\n  align-self: end;\n\n  color: ",
        ";\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 1.3;\n  letter-spacing: 0.64rpx;\n\n  ",
        " {\n    margin-bottom: 20px;\n    padding-left: 40px;\n  }\n  ",
        " {\n    padding-left: 0;\n    padding-right: 30px;\n\n    ",
        " {\n      padding-left: 0;\n      padding-right: 40px;\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: title;\n  margin-bottom: 10px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: description;\n  padding-left: 30px;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 1.5;\n\n  ",
        " {\n    width: 250px;\n    padding-left: 40px;\n  }\n\n  ",
        " {\n    padding-left: 0;\n    padding-right: 30px;\n\n    ",
        " {\n      padding-left: 0;\n      padding-right: 40px;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: cta;\n  padding-left: 30px;\n\n  color: ",
        ";\n  font-size: 14px;\n  line-height: 1.3;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n\n  ",
        " {\n    padding-left: 40px;\n  }\n  ",
        " {\n    padding-left: 0;\n    padding-right: 30px;\n\n    ",
        " {\n      padding-left: 0;\n      padding-right: 40px;\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}













var LeftImageSection = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventsPresentationStaticSection__LeftImageSection",
    componentId: "sc-2cf50d68-0"
})(EventsPresentationStaticSection_templateObject(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop, theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var ImageContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventsPresentationStaticSection__ImageContainer",
    componentId: "sc-2cf50d68-1"
})(_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var StyledImage = (0,styled_components_browser_esm["default"])((image_default())).withConfig({
    displayName: "EventsPresentationStaticSection__StyledImage",
    componentId: "sc-2cf50d68-2"
})(_templateObject2());
var Subtitle = styled_components_browser_esm["default"].h4.withConfig({
    displayName: "EventsPresentationStaticSection__Subtitle",
    componentId: "sc-2cf50d68-3"
})(_templateObject3(), (0,theme/* fromTheme */.HW)(function(a) {
    return a.text.palette.secondary;
}), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Title = (0,styled_components_browser_esm["default"])(Header.H1).attrs({
    as: "h2"
}).withConfig({
    displayName: "EventsPresentationStaticSection__Title",
    componentId: "sc-2cf50d68-4"
})(_templateObject4());
var Description = styled_components_browser_esm["default"].p.withConfig({
    displayName: "EventsPresentationStaticSection__Description",
    componentId: "sc-2cf50d68-5"
})(_templateObject5(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var CTA = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventsPresentationStaticSection__CTA",
    componentId: "sc-2cf50d68-6"
})(_templateObject6(), (0,theme/* fromTheme */.HW)(function(a) {
    return a.text.font.secondary;
}), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventsPresentationStaticSection = function() {
    var _ = (0,lib.useTranslate)()._;
    var data = useUpcomingEventsPageQuery().data;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(LeftImageSection, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageContainer, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                        src: lol_event_section,
                        layout: "fill"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Subtitle, {
                    children: _("EXCLUSIVE EVENTS")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                    children: _("NEAUVIA EXPERTS CERTIFICATION")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Description, {
                    children: _("NEAUVIA EXPERTS CERTIFICATION description")
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CTA, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                        href: (ref = data === null || data === void 0 ? void 0 : data.neauviaExpertsCertificationLink) !== null && ref !== void 0 ? ref : "",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.zx, {
                            kind: "text",
                            as: "a",
                            children: _("Discover more")
                        })
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react-hook-inview/dist/esm/index.js + 2 modules
var esm = __webpack_require__(69671);
// EXTERNAL MODULE: ./src/styles/common.ts
var common = __webpack_require__(12258);
// EXTERNAL MODULE: ./vendor/mods/markdown/components/Markdown.tsx
var Markdown = __webpack_require__(15201);
// EXTERNAL MODULE: ./src/modules/events/hooks/useFlattenEvent.ts
var useFlattenEvent = __webpack_require__(73082);
// EXTERNAL MODULE: ./src/modules/events/components/EventCountdown.tsx
var EventCountdown = __webpack_require__(44558);
// EXTERNAL MODULE: ./src/services/route.ts + 1 modules
var route = __webpack_require__(38325);
// EXTERNAL MODULE: ./src/components/icons/Calendar.tsx
var Calendar = __webpack_require__(66105);
// EXTERNAL MODULE: ./src/components/icons/ChevronRight.tsx
var ChevronRight = __webpack_require__(38108);
// EXTERNAL MODULE: ./src/modules/events/components/UserEvents/UserEventsEventButton.tsx
var UserEventsEventButton = __webpack_require__(46855);
;// CONCATENATED MODULE: ./src/modules/events/components/EventsPresentationGallery/EventPresentationCTAs.tsx

function EventPresentationCTAs_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: column;\n  max-width: 250px;\n  gap: 8px;\n\n  margin-top: 24px;\n\n  ",
        " {\n    min-width: 100%;\n  }\n"
    ]);
    EventPresentationCTAs_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPresentationCTAs_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 12px;\n  max-width: max-content !important;\n"
    ]);
    EventPresentationCTAs_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}










var Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPresentationCTAs__Container",
    componentId: "sc-f23aa06-0"
})(EventPresentationCTAs_templateObject(), Button/* FullWidthButton */.Ow);
var CalendarButton = (0,styled_components_browser_esm["default"])(Button/* Button */.zx).withConfig({
    displayName: "EventPresentationCTAs__CalendarButton",
    componentId: "sc-f23aa06-1"
})(EventPresentationCTAs_templateObject1());
var EventPresentationCTAs = function(param) {
    var event = param.event, isUpcoming = param.isUpcoming;
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrackedLink/* TrackedLink */.A, {
                href: route/* route.event */.BC.event(event).page(),
                passHref: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* FullWidthButton */.Ow, {
                    icon: ChevronRight/* ChevronRight */._,
                    iconProps: {
                        position: "right",
                        size: 12
                    },
                    variant: "secondary",
                    children: _("SEE MORE")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UserEventsEventButton/* UserEventsEventButton */.J, {
                event: event
            }),
            isUpcoming && /*#__PURE__*/ (0,jsx_runtime.jsx)(CalendarButton, {
                kind: "text",
                forwardedAs: "a",
                href: route/* route.event */.BC.event(event).ics(),
                icon: Calendar/* default */.Z,
                children: _("Add to calendar")
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/common/FormatDate.tsx
var FormatDate = __webpack_require__(23955);
// EXTERNAL MODULE: ./src/hooks/useTimeState.ts
var useTimeState = __webpack_require__(12597);
// EXTERNAL MODULE: ./src/modules/events/hooks/useIsMultidayEvent.ts
var useIsMultidayEvent = __webpack_require__(80141);
// EXTERNAL MODULE: ./src/components/common/DirectusImage.tsx
var DirectusImage = __webpack_require__(52520);
;// CONCATENATED MODULE: ./src/modules/events/components/EventsPresentationGallery/EventPresentationContent.tsx
/* eslint-disable react/display-name */ 
function EventPresentationContent_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 100%;\n  width: 215px;\n  margin-left: 120px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n\n  ",
        " {\n    width: 500px;\n    margin-left: 250px;\n  }\n\n  ",
        " {\n    margin-right: 120px;\n    margin-left: 0;\n    ",
        " {\n      margin-left: 0;\n      margin-right: 250px;\n    }\n  }\n"
    ]);
    EventPresentationContent_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPresentationContent_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-style: normal;\n  font-weight: 300;\n  font-size: 16px;\n  line-height: 150%;\n  white-space: nowrap;\n  margin-bottom: 8px;\n\n  ",
        " {\n    margin-bottom: 12px;\n  }\n"
    ]);
    EventPresentationContent_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPresentationContent_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-bottom: 12px;\n  overflow-wrap: break-word;\n\n  ",
        " {\n    margin-bottom: 24px;\n  }\n"
    ]);
    EventPresentationContent_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPresentationContent_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 32px;\n  font-weight: 300;\n  line-height: 1;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n"
    ]);
    EventPresentationContent_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EventPresentationContent_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 350px;\n\n  font-size: 32px;\n  font-weight: 200;\n  line-height: 1;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n"
    ]);
    EventPresentationContent_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function EventPresentationContent_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 350px;\n\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 150%;\n\n  ",
        " {\n    display: none;\n  }\n"
    ]);
    EventPresentationContent_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function EventPresentationContent_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  max-width: 350px;\n\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 1.5;\n  ",
        ";\n\n  ",
        " {\n    margin-top: 22px;\n    ",
        ";\n  }\n"
    ]);
    EventPresentationContent_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-transform: uppercase;\n  letter-spacing: 0.64rpx;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 122px;\n  height: 45px;\n  margin-top: -48px;\n  margin-bottom: 12px;\n  ",
        " {\n    width: 162px;\n    height: 64px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}















var EventPresentationContent_Container = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPresentationContent__Container",
    componentId: "sc-30caad0e-0"
})(EventPresentationContent_templateObject(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var DateContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPresentationContent__DateContainer",
    componentId: "sc-30caad0e-1"
})(EventPresentationContent_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var TitleContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPresentationContent__TitleContainer",
    componentId: "sc-30caad0e-2"
})(EventPresentationContent_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Name = styled_components_browser_esm["default"].h2.withConfig({
    displayName: "EventPresentationContent__Name",
    componentId: "sc-30caad0e-3"
})(EventPresentationContent_templateObject3());
var EventPresentationContent_Title = styled_components_browser_esm["default"].h3.withConfig({
    displayName: "EventPresentationContent__Title",
    componentId: "sc-30caad0e-4"
})(EventPresentationContent_templateObject4());
var EventPresentationContent_Description = styled_components_browser_esm["default"].p.withConfig({
    displayName: "EventPresentationContent__Description",
    componentId: "sc-30caad0e-5"
})(EventPresentationContent_templateObject5(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var Tags = styled_components_browser_esm["default"].p.withConfig({
    displayName: "EventPresentationContent__Tags",
    componentId: "sc-30caad0e-6"
})(EventPresentationContent_templateObject6(), (0,common/* lineClamp */.Sf)(3), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, (0,common/* lineClamp */.Sf)(2));
var TagsTitle = styled_components_browser_esm["default"].span.withConfig({
    displayName: "EventPresentationContent__TagsTitle",
    componentId: "sc-30caad0e-7"
})(_templateObject7());
var LogoContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPresentationContent__LogoContainer",
    componentId: "sc-30caad0e-8"
})(_templateObject8(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPresentationContent = /*#__PURE__*/ (0,react.memo)(function(param) {
    var event = param.event;
    var ref, ref1, ref2;
    var ref3 = (0,react.useRef)(null);
    var _ = (0,lib.useTranslate)()._;
    var flatEvent = (0,useFlattenEvent/* useFlattenEvent */.p)(event);
    var ref4 = (0,useTimeState/* useTimeState */.RA)(flatEvent), isNow = ref4.isNow, isUpcoming = ref4.isUpcoming;
    var isMultiDayEvent = (0,useIsMultidayEvent/* useIsMultidayEvent */.U)(flatEvent).isMultiDayEvent;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPresentationContent_Container, {
                ref: ref3,
                children: [
                    flatEvent.logo && /*#__PURE__*/ (0,jsx_runtime.jsx)(LogoContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DirectusImage/* DirectusImage */.q, {
                            src: flatEvent.logo.id,
                            layout: "fill",
                            objectFit: "contain",
                            objectPosition: "0 50%"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(DateContainer, {
                        children: isMultiDayEvent ? isNow ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                _("Ends on"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatDate */.r2, {
                                    format: "dd.LL",
                                    children: event.endDate
                                }),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                                    children: event.endDate
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                _("Starts at"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                                    children: event.startDate
                                })
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                                    children: event.startDate
                                }),
                                "\xa0-\xa0",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatHour */.t, {
                                    children: event.endDate
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(TitleContainer, {
                        children: [
                            ((ref = flatEvent.type) === null || ref === void 0 ? void 0 : ref.name) != null && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                        children: (ref1 = flatEvent.type) === null || ref1 === void 0 ? void 0 : ref1.name
                                    }),
                                    flatEvent.name && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPresentationContent_Title, {
                                        children: flatEvent.name
                                    })
                                ]
                            }),
                            ((ref2 = flatEvent.type) === null || ref2 === void 0 ? void 0 : ref2.name) == null && /*#__PURE__*/ (0,jsx_runtime.jsx)(Name, {
                                children: flatEvent.name
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPresentationContent_Description, {
                        children: flatEvent.excerpt && /*#__PURE__*/ (0,jsx_runtime.jsx)(Markdown/* Markdown */.U, {
                            children: flatEvent.excerpt
                        })
                    }),
                    flatEvent.tags.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tags, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(TagsTitle, {
                                children: [
                                    _("EVENT TOPICS"),
                                    ": "
                                ]
                            }),
                            flatEvent.tags.map(function(a) {
                                return a.name;
                            }).join(", ")
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPresentationCTAs, {
                        event: event,
                        isUpcoming: isUpcoming
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventCountdown/* EventCountdown */.e, {
                event: event
            })
        ]
    });
});

// EXTERNAL MODULE: ./node_modules/@react-hook/merged-ref/dist/module/index.js
var dist_module = __webpack_require__(27006);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(81041);
;// CONCATENATED MODULE: ./src/modules/events/components/EventsPresentationGallery/EventPresentation.tsx


function EventPresentation_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 600px;\n  max-height: 900px;\n  height: calc(100vh - var(--header-fixed-height) + 1px);\n\n  background: ",
        ";\n\n  &:first-of-type {\n    height: calc(100vh - var(--header-static-height) + 1px);\n  }\n"
    ]);
    EventPresentation_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPresentation_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 100%;\n"
    ]);
    EventPresentation_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPresentation_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  object-fit: cover;\n  object-position: 20% top;\n\n  ",
        " {\n    object-fit: contain;\n    object-position: 70% center;\n    ",
        " {\n      object-position: 0% center;\n    }\n  }\n"
    ]);
    EventPresentation_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












var Section = (0,styled_components_browser_esm["default"])(motion/* motion.li */.E.li).withConfig({
    displayName: "EventPresentation__Section",
    componentId: "sc-2e677e4a-0"
})(EventPresentation_templateObject(), function(param) {
    var theme = param.theme, $background = param.$background;
    return $background !== null && $background !== void 0 ? $background : theme.palette.background;
});
var EventPresentation_Container = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventPresentation__Container",
    componentId: "sc-2e677e4a-1"
})(EventPresentation_templateObject1());
var BackgroundImage = (0,styled_components_browser_esm["default"])((image_default())).withConfig({
    displayName: "EventPresentation__BackgroundImage",
    componentId: "sc-2e677e4a-2"
})(EventPresentation_templateObject2(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX);
var EventPresentation = /*#__PURE__*/ (0,react.memo)(/*#__PURE__*/ (0,react.forwardRef)(function(param, ref) {
    var event = param.event, onIntersection = param.onIntersection;
    var _$ref, _$ref1;
    var observerRef = (0,esm/* useInViewEffect */.R)(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), entry = _param[0];
        onIntersection(event.id, entry.intersectionRatio);
    }, {
        threshold: [
            0.25,
            0.5,
            0.75,
            1
        ]
    }, [
        onIntersection
    ]);
    var mergedRef = (0,dist_module/* default */.Z)(observerRef, ref);
    var _image;
    var backgroundImage = (_image = event.image) !== null && _image !== void 0 ? _image : (_$ref = event.type) === null || _$ref === void 0 ? void 0 : _$ref.image;
    var _background;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section, {
        ref: mergedRef,
        $background: (_background = event.background) !== null && _background !== void 0 ? _background : (_$ref1 = event.type) === null || _$ref1 === void 0 ? void 0 : _$ref1.background,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPresentation_Container, {
            children: [
                backgroundImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage, {
                    as: DirectusImage/* DirectusImage */.q,
                    src: backgroundImage.id,
                    layout: "fill"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPresentationContent, {
                    event: event
                })
            ]
        })
    });
}));
EventPresentation.displayName = "EventPresentation";

// EXTERNAL MODULE: ./src/components/common/ResponsiveUnit.tsx
var ResponsiveUnit = __webpack_require__(47631);
// EXTERNAL MODULE: ./src/providers/LayoutRegisterProvider.tsx
var LayoutRegisterProvider = __webpack_require__(63085);
// EXTERNAL MODULE: ./node_modules/polished/dist/polished.esm.js + 6 modules
var polished_esm = __webpack_require__(17573);
;// CONCATENATED MODULE: ./src/modules/events/components/EventsPresentationGallery/EventPresentationTimeline.tsx

function EventPresentationTimeline_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: sticky;\n  top: var(--header-fixed-height);\n  height: calc(100vh - var(--header-fixed-height));\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  justify-content: center;\n  padding: 50px 0 calc(50px + var(--header-fixed-height));\n\n  ",
        " {\n    margin-left: calc(-1 * var(--constraint-container-left-margin) + 6px);\n  }\n"
    ]);
    EventPresentationTimeline_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventPresentationTimeline_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 110px;\n  overflow: hidden;\n\n  ",
        " {\n    width: 200px;\n  }\n"
    ]);
    EventPresentationTimeline_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventPresentationTimeline_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  left: 4rpx;\n  bottom: 0;\n  width: 1rpx;\n  opacity: 0.4;\n  background: linear-gradient(\n    to bottom,\n    ",
        ",\n    ",
        " 15%,\n    ",
        " 85%,\n    ",
        " 100%\n  );\n\n  ",
        " {\n    left: 5rpx;\n  }\n\n  ",
        " {\n    right: 4rpx;\n    left: auto;\n    ",
        " {\n      right: 5rpx;\n      left: auto;\n    }\n  }\n"
    ]);
    EventPresentationTimeline_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventPresentationTimeline_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  grid-area: date;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n"
    ]);
    EventPresentationTimeline_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function EventPresentationTimeline_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: -20px;\n  top: 50%;\n  ",
        " {\n    right: -20px;\n    left: auto;\n  }\n\n  transform: translateY(-50%) scale(0.6);\n\n  width: 9rpx;\n  height: 9rpx;\n  background: ",
        ";\n  border-radius: 50%;\n  transition: all 300ms ",
        ";\n\n  ",
        " {\n    width: 11rpx;\n    height: 11rpx;\n  }\n"
    ]);
    EventPresentationTimeline_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function EventPresentationTimeline_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  grid-area: name;\n  font-size: 80%;\n  transition: all 300ms ",
        ";\n"
    ]);
    EventPresentationTimeline_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function EventPresentationTimeline_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: #ffffff;\n          background-color: #4f4f4f;\n        "
    ]);
    EventPresentationTimeline_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function EventPresentationTimeline_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: #4f4f4f;\n          background-color: #f2f2f2;\n        "
    ]);
    EventPresentationTimeline_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function EventPresentationTimeline_templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n          color: #ffffff;\n          background-color: #cd0338;\n        "
    ]);
    EventPresentationTimeline_templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2px 4px;\n  text-transform: uppercase;\n  line-height: 1;\n  font-size: 60%;\n\n  ",
        ";\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding-left: 20px;\n  font-weight: 300;\n  font-size: 10px;\n  line-height: 1.25;\n  display: grid;\n  letter-spacing: 0.64rpx;\n  text-transform: uppercase;\n  margin: 10px 0;\n  transform-origin: left center;\n  transition: all 300ms ",
        ";\n  grid-template-areas: 'date date' 'name name';\n  grid-template-columns: auto auto;\n  grid-column-gap: 6px;\n  grid-row-gap: 4px;\n  text-align: left;\n  ",
        " {\n    padding-left: 0;\n    padding-right: 20px;\n  }\n\n  &:not(:last-child):not(.EventPresentationTimelineItem-active) {\n    margin-bottom: 16px;\n  }\n\n  &.EventPresentationTimelineItem-active {\n    font-weight: bold;\n    font-size: 14px;\n\n    & ",
        " {\n      transform: translateY(-50%) scale(1);\n    }\n\n    & > ",
        " {\n      opacity: 0;\n      transform: translateX(100px);\n    }\n  }\n\n  &.EventPresentationTimelineItem-active + & {\n    font-size: 13px;\n    letter-spacing: 0.06em;\n  }\n\n  ",
        " {\n    font-size: 11px;\n\n    &.EventPresentationTimelineItem-active {\n      font-size: 20px;\n    }\n\n    &.EventPresentationTimelineItem-active + & {\n      font-size: 16px;\n      letter-spacing: 0.06em;\n    }\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}













var StickyContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPresentationTimeline__StickyContainer",
    componentId: "sc-344b56bf-0"
})(EventPresentationTimeline_templateObject(), designs/* media.w.lessThan.desktop */.BC.w.lessThan.desktop);
var EventPresentationTimeline_Container = styled_components_browser_esm["default"].nav.withConfig({
    displayName: "EventPresentationTimeline__Container",
    componentId: "sc-344b56bf-1"
})(EventPresentationTimeline_templateObject1(), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var Line = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventPresentationTimeline__Line",
    componentId: "sc-344b56bf-2"
})(EventPresentationTimeline_templateObject2(), (0,theme/* fromTheme */.HW)(function(a) {
    return (0,polished_esm/* transparentize */.DZ)(1, a.text.palette.primary);
}), (0,theme/* fromTheme */.HW)(function(a) {
    return a.text.palette.primary;
}), (0,theme/* fromTheme */.HW)(function(a) {
    return a.text.palette.primary;
}), (0,theme/* fromTheme */.HW)(function(a) {
    return (0,polished_esm/* transparentize */.DZ)(1, a.text.palette.primary);
}), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop, theme/* dirRTL */.gX, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPresentationTimeline_Date = styled_components_browser_esm["default"].span.withConfig({
    displayName: "EventPresentationTimeline__Date",
    componentId: "sc-344b56bf-3"
})(EventPresentationTimeline_templateObject3());
var Dot = styled_components_browser_esm["default"].span.withConfig({
    displayName: "EventPresentationTimeline__Dot",
    componentId: "sc-344b56bf-4"
})(EventPresentationTimeline_templateObject4(), theme/* dirRTL */.gX, (0,theme/* fromTheme */.HW)(function(a) {
    return a.text.palette.primary;
}), (0,theme/* fromTheme */.HW)(function(a) {
    return a.animation.easing.decelerated;
}), designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var EventPresentationTimeline_Name = styled_components_browser_esm["default"].span.withConfig({
    displayName: "EventPresentationTimeline__Name",
    componentId: "sc-344b56bf-5"
})(EventPresentationTimeline_templateObject5(), (0,theme/* fromTheme */.HW)(function(a) {
    return a.animation.easing.decelerated;
}));
var Form = styled_components_browser_esm["default"].span.withConfig({
    displayName: "EventPresentationTimeline__Form",
    componentId: "sc-344b56bf-6"
})(_templateObject9(), function(param) {
    var form = param.form;
    switch(form){
        case "hybrid":
            return (0,styled_components_browser_esm.css)(EventPresentationTimeline_templateObject6());
        case "offline":
            return (0,styled_components_browser_esm.css)(EventPresentationTimeline_templateObject7());
        default:
            return (0,styled_components_browser_esm.css)(EventPresentationTimeline_templateObject8());
    }
});
var Item = (0,styled_components_browser_esm["default"])(Button/* CleanButton */.ux).withConfig({
    displayName: "EventPresentationTimeline__Item",
    componentId: "sc-344b56bf-7"
})(_templateObject10(), (0,theme/* fromTheme */.HW)(function(a) {
    return a.animation.easing.decelerated;
}), theme/* dirRTL */.gX, Dot, EventPresentationTimeline_Name, designs/* media.w.greaterThanOrEqual.desktop */.BC.w.greaterThanOrEqual.desktop);
var TimelineItem = /*#__PURE__*/ (0,react.memo)(function(param) {
    var event = param.event, active = param.active, px = param.px, sectionsRef = param.sectionsRef;
    var ref, ref1;
    var layoutRegisterContext = (0,react.useContext)(LayoutRegisterProvider/* LayoutRegisterContext */.D);
    var onClick = (0,react.useCallback)(function() {
        var ref;
        var section = (ref = sectionsRef.current) === null || ref === void 0 ? void 0 : ref[event.id];
        if (section != null) {
            var ref1;
            var _fixed;
            window.scrollTo({
                top: section.getBoundingClientRect().top + window.scrollY - ((_fixed = (ref1 = layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.ui.height) === null || ref1 === void 0 ? void 0 : ref1.header.fixed) !== null && _fixed !== void 0 ? _fixed : 0) * px,
                behavior: "smooth"
            });
        }
    }, [
        px,
        (ref = layoutRegisterContext === null || layoutRegisterContext === void 0 ? void 0 : layoutRegisterContext.ui.height) === null || ref === void 0 ? void 0 : ref.header.fixed
    ]);
    var flatEvent = (0,useFlattenEvent/* useFlattenEvent */.p)(event);
    var isNow = (0,useTimeState/* useTimeState */.RA)(event).isNow;
    var _ = (0,lib.useTranslate)()._;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Item, {
        onClick: onClick,
        className: active ? "EventPresentationTimelineItem-active" : "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPresentationTimeline_Date, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Dot, {}),
                    isNow ? /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: _("now")
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FormatDate/* FormatDate */.r2, {
                        format: "dd.LL",
                        children: flatEvent.startDate
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Form, {
                        form: flatEvent.form,
                        children: flatEvent.form
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPresentationTimeline_Name, {
                children: ((ref1 = flatEvent.type) === null || ref1 === void 0 ? void 0 : ref1.name) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                            children: flatEvent.type.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                        flatEvent.name
                    ]
                }) : flatEvent.name
            })
        ]
    }, event.id);
});
var EventPresentationTimeline = /*#__PURE__*/ (0,react.memo)(function(param) {
    var activeId = param.activeId, events = param.events, sectionsRef = param.sectionsRef;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveUnit/* ResponsiveUnit */.D, {
        children: function(px) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(EventPresentationTimeline_Container, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Line, {}),
                        events.map(function(a) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineItem, {
                                event: a,
                                px: px,
                                active: a.id === activeId,
                                sectionsRef: sectionsRef
                            }, a.id);
                        })
                    ]
                })
            });
        }
    });
});

;// CONCATENATED MODULE: ./src/modules/events/components/EventsPresentationGallery/index.tsx


function EventsPresentationGallery_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  color: ",
        ";\n  position: relative;\n"
    ]);
    EventsPresentationGallery_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function EventsPresentationGallery_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  height: 0;\n"
    ]);
    EventsPresentationGallery_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function EventsPresentationGallery_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 50;\n  width: 0;\n"
    ]);
    EventsPresentationGallery_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function EventsPresentationGallery_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 0;\n  padding: 0;\n"
    ]);
    EventsPresentationGallery_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}








var StickyUIContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventsPresentationGallery__StickyUIContainer",
    componentId: "sc-ccf2d2e-0"
})(EventsPresentationGallery_templateObject(), function(param) {
    var theme = param.theme;
    return theme.text.palette.primary;
});
var StickyUISpace = (0,styled_components_browser_esm["default"])(ConstraintContainer/* ConstraintContainer */.a).withConfig({
    displayName: "EventsPresentationGallery__StickyUISpace",
    componentId: "sc-ccf2d2e-1"
})(EventsPresentationGallery_templateObject1());
var TimelineContainer = styled_components_browser_esm["default"].div.withConfig({
    displayName: "EventsPresentationGallery__TimelineContainer",
    componentId: "sc-ccf2d2e-2"
})(EventsPresentationGallery_templateObject2());
var Content = (0,styled_components_browser_esm["default"])(motion/* motion.ol */.E.ol).withConfig({
    displayName: "EventsPresentationGallery__Content",
    componentId: "sc-ccf2d2e-3"
})(EventsPresentationGallery_templateObject3());
var animationConfig = {
    show: {
        transition: {
            staggerChildren: 0.05
        }
    }
};
var EventsPresentationGallery = /*#__PURE__*/ (0,react.memo)(function EventsPresentationGallery(param) {
    var events = param.events;
    var ref = (0,react.useState)(events[0].id), activeNavigationItem = ref[0], setActiveNavigationItem = ref[1];
    var intersectionValues = (0,react.useRef)({});
    var onIntersection = (0,react.useCallback)(function(id, intersectionRatio) {
        var ref;
        intersectionValues.current[id] = intersectionRatio;
        var current = (ref = Object.entries(intersectionValues.current).find(function(param) {
            var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
            return value >= 0.5;
        })) === null || ref === void 0 ? void 0 : ref[0];
        if (current != null) {
            setActiveNavigationItem(current);
        }
    }, []);
    var sectionsRef = (0,react.useRef)({});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm.ThemeProvider, {
        theme: theme/* redTheme */.MN,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyUIContainer, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyUISpace, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TimelineContainer, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPresentationTimeline, {
                            events: events,
                            sectionsRef: sectionsRef,
                            activeId: activeNavigationItem
                        })
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Content, {
                    variants: animationConfig,
                    initial: "hide",
                    animate: "show",
                    children: events.map(function(a, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(EventPresentation, {
                            isFirst: i === 0,
                            event: a,
                            ref: function(b) {
                                return sectionsRef.current[a.id] = b;
                            },
                            onIntersection: onIntersection
                        }, a.id);
                    })
                }, "EventsPresentationGalleryAnimation")
            ]
        })
    });
});

// EXTERNAL MODULE: ./src/modules/events/hooks/useUpcomingEventsListQuery.ts
var useUpcomingEventsListQuery = __webpack_require__(93928);
// EXTERNAL MODULE: ./src/modules/events/templates/EventsGalleryTemplate.tsx
var EventsGalleryTemplate = __webpack_require__(51961);
;// CONCATENATED MODULE: ./src/modules/events/templates/UpcomingEventsTemplate.tsx






var UpcomingEventsTemplate = function() {
    var ref = (0,useUpcomingEventsListQuery/* useUpcomingEventsListQuery */.k)(), events = ref.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsGalleryTemplate/* EventsGalleryTemplate */.a, {
                type: "upcoming",
                hasResults: !!(events === null || events === void 0 ? void 0 : events.length),
                children: events && events.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsPresentationGallery, {
                    events: events
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EventsPresentationStaticSection, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/events/upcoming.tsx

var __N_SSP = true;
/* harmony default export */ var upcoming = (UpcomingEventsTemplate);


/***/ }),

/***/ 69671:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* reexport */ esm_useInView; },
  "R": function() { return /* reexport */ esm_useObserver; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-hook-inview/dist/esm/useObserver.js

/**
 * useObserver
 * @param callback IntersectionObserverCallback
 * @param options IntersectionObserverInit
 * @param externalState React.ComponentState[]
 */
const useObserver = (callback, { root, rootMargin, threshold } = {}, externalState = []) => {
    const target = (0,react.useRef)(null);
    const observer = (0,react.useRef)(null);
    const setTarget = (0,react.useCallback)((node) => {
        if (target.current && observer.current) {
            observer.current.unobserve(target.current);
            observer.current.disconnect();
            observer.current = null;
        }
        if (node) {
            observer.current = new IntersectionObserver(callback, { root, rootMargin, threshold });
            observer.current.observe(node);
            target.current = node;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [target, root, rootMargin, threshold, ...externalState]);
    return setTarget;
};
/* harmony default export */ var esm_useObserver = (useObserver);

;// CONCATENATED MODULE: ./node_modules/react-hook-inview/dist/esm/useInView.js


/**
 * useInView
 * @param options IntersectionObserverInit
 * @param externalState React.ComponentState[]
 */
const useInView = ({ root, rootMargin, threshold, unobserveOnEnter, target, onEnter, onLeave } = {}, externalState = []) => {
    const [state, setState] = (0,react.useState)({
        inView: false,
        entry: null,
        observer: null,
    });
    const callback = (0,react.useCallback)(([entry], observer) => {
        const inThreshold = observer.thresholds.some((t) => entry.intersectionRatio >= t);
        const inView = inThreshold && entry.isIntersecting;
        setState({
            inView,
            entry,
            observer,
        });
        // unobserveOnEnter
        if (inView && unobserveOnEnter) {
            observer.unobserve(entry.target);
            observer.disconnect();
        }
        // Legacy callbacks
        if (inView) {
            onEnter === null || onEnter === void 0 ? void 0 : onEnter(entry, observer);
        }
        else {
            onLeave === null || onLeave === void 0 ? void 0 : onLeave(entry, observer);
        }
    }, [onEnter, onLeave, unobserveOnEnter]);
    const setTarget = esm_useObserver(callback, { root, rootMargin, threshold }, [unobserveOnEnter, ...externalState]);
    // Legacy 'target' option
    (0,react.useEffect)(() => {
        if (target === null || target === void 0 ? void 0 : target.current)
            setTarget(target.current);
    }, [target, setTarget]);
    return [setTarget, state.inView, state.entry, state.observer];
};
/* harmony default export */ var esm_useInView = (useInView);

;// CONCATENATED MODULE: ./node_modules/react-hook-inview/dist/esm/index.js




/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [8554,2560,9774,2888,179], function() { return __webpack_exec__(20831); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);